import SupportedLobModules from 'integration/policyTransaction/SupportedLobModules';
import 'edge/policyjob/app';
import 'edge/policycommon/app';
import 'edge/platform/navigation/module';

var dependencies = SupportedLobModules;

dependencies.push('edge.policyjob.app');
dependencies.push('edge.policycommon.app');
dependencies.push('edge.platform.navigation');

export default angular.module('edge.transaction.app', dependencies);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-angular/module.js
// module id = 1838
// module chunks = 0